export enum User {
    ADMIN = "Administrador",
    COVENANT = "Convênio"
}